import React from 'react';
import { useSelector } from 'react-redux';
import type { MenuProps } from 'antd';
import { Dropdown, Popconfirm } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { RootState } from '@/stores';
import './HeadContent.css';

export default function HeadContent() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const username = useSelector((state: RootState) => state.User.info.username);
  const logout = () => {
    dispatch({ type: 'USER_LOGOUT' });
    dispatch({ type: 'CLEAR_MENU' });
    navigate('/', { replace: true });
  }
  const items: MenuProps['items'] = [
    {
      key: 'SETTING',
      label: (
        <span>系统设置</span>
      ),
    },
    {
      key: 'LOGOUT',
      label: (
        <>
          <Popconfirm
            title="提示"
            description="确定退出登录?"
            onConfirm={logout}
            okText="确定"
            cancelText="取消"
          >
            <span>退出登录</span>
          </Popconfirm>
        </>
      ),
    },
  ];

  return(
    <section className="HeadContent">
      <section className="slogan">欢迎登录机器人系统管理平台</section>
      <section className="user-config">
        <section className="user">
          <section className="user-icon"></section>
          <section>{username}</section>
        </section>
        <section className="config">
          <Dropdown menu={{ items }} placement="bottomRight">
            <section className="config-icon"></section>
          </Dropdown>
        </section>
      </section>
    </section>
  )
}